export function getSelectedRangeHtml(document, range) {
  var clonedSelection = range.cloneContents();
  const div = document.createElement("div");
  div.appendChild(clonedSelection);
  return div.innerHTML;
}
